import React, { Fragment, useState } from "react";
import "./index.css";
import { Link } from "react-router-dom";
export interface questions {
  name: string;
  questions?: Array<responses | null>;
}
export interface responses {
  title: string;
  response: string;
}
function HomeParisPage() {
  const PQRS = [
    {
      name: "¿Leyó el <b>manual de instalación</b> de la página de descarga?",
    },
    {
      name: "<b>¿Se solicitó alta de usuario a través del formulario?</b> El embajador tendrá la información de todos los usuarios de su local que se han dado de alta, por lo tanto, tiene que buscar en ese listado, el cual será entregado por mail.",
    },
    {
      name: "¿Tiene acceso al </b>link de instalación?</b>",
    },
    {
      name: "Si no es ninguna de las anteriores el referente <b>debe completar el formulario.</b>",
    },
  ];
  const responses = [
    {
      title: "<b>¿Puedo gestionar más de un local?</b>",
      response: "Solo se puede gestionar y visualizar un local.",
    },
    {
      title: "<b>¿La APP está disponible para los computadores?</b>",
      response:
        "No, sólo está disponible para dispositivos móviles (celulares y PDA).",
    },
  ];

  const [toggle, setToggle] = useState<boolean>(false);
  return (
    <Fragment>
      <div className="home-paris-page">
        <div className="content mb-0">
          <img src="assets/img/paris/home/1.svg" alt="logo" />
          <div className="col">
            <div className="row">
              <div className="col-8">
                <h2>Aspectos generales </h2>
              </div>
              <div className="col-4">
                {toggle ? (
                  <img
                    src="assets/img/paris/home/4.svg"
                    alt="logo"
                    onClick={() => setToggle(!toggle)}
                  />
                ) : (
                  <img
                    src="assets/img/paris/home/5.svg"
                    alt="logo"
                    onClick={() => setToggle(!toggle)}
                  />
                )}
              </div>
            </div>

            {toggle && (
              <>
                <p className="text">
                  Para descargar la App, puedes hacerlo utilizando cualquiera de
                  estos link que incluyen además el manual de descarga. Debes
                  seleccionar el sistema operativo correspondiente.
                </p>
                <button className="btn">
                  <div className="col-6">
                    <img src="assets/img/paris/home/3.svg" alt="logo" />
                  </div>
                  <div className="col-6">
                    <Link to={"/android-paris"}>Instructivos Android</Link>
                  </div>
                </button>
                <p className="text">
                  ¿Qué hago si tengo problemas al instalar la APP?
                </p>
                <p className="text">
                  Debes canalizar estas inquietudes con el Encargado del local,
                  el cual debe ir descartando el problema de acuerdo a las
                  siguientes preguntas:
                </p>
                <ul className="sec__questions">
                  {PQRS.map((data: questions) => {
                    return (
                      <li
                        dangerouslySetInnerHTML={{ __html: data.name }}
                        key={data.name}
                      ></li>
                    );
                  })}
                </ul>
                <div>
                  {responses.map((data: responses) => {
                    return (
                      <React.Fragment key={data.title}>
                        <div className="title__responses">
                          <p
                            dangerouslySetInnerHTML={{ __html: data.title }}
                          ></p>
                          <p className="text">{data.response}</p>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              </>
            )}
          </div>

          <div className="col">
            <h3>Instructivos de uso</h3>
            <p className="text__instructivos">
              ¡Aclara tus dudas, revisando las principales tareas y
              funcionalidades!
            </p>
            <Link to="/ayuda-paris" className="btn__instructivos">
              <button>Ir a instructivos</button>
            </Link>
          </div>

          <div className="content mb-0">
            <img src="assets/img/paris/home/2.svg" alt="logo" className="img__footer"/>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default HomeParisPage;
